// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { logger } from "@/lib/logger";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AuthCallbackPage() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  // useRef para evitar re-executar sob StrictMode (effect roda 2x)
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      toast.error("Sessão Google ausente");
      nav("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);

    (async () => {
      try {
        const r = await api.post("/auth/google/callback", { session_id: sessionId });
        setUser(r.data.user);
        // Limpa a hash do browser para o session_id não ficar no histórico
        window.history.replaceState(null, "", window.location.pathname);
        if (r.data.needs_cpf_link) {
          toast.success(`Bem-vindo(a), ${r.data.user.nome}! Precisamos do seu CPF.`);
          nav("/vincular-cpf", { replace: true });
        } else {
          toast.success(`Bem-vindo(a) de volta, ${r.data.user.nome.split(" ")[0]}!`);
          nav("/area-cidadao", { replace: true });
        }
      } catch (e) {
        logger.error("Falha no callback Google", e);
        toast.error(e.response?.data?.detail || "Falha ao autenticar com Google");
        nav("/login", { replace: true });
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F6F9]" data-testid="auth-callback-page">
      <div className="text-center">
        <Loader2 className="w-10 h-10 animate-spin text-[#083CA6] mx-auto mb-4" />
        <h1 className="text-lg font-bold text-slate-800">Entrando com Google...</h1>
        <p className="text-sm text-slate-500 mt-1">Validando sessão de forma segura.</p>
      </div>
    </div>
  );
}
